<template>
  <div class="create-after-sale">
    <button type='button' class='btn btn-sm btn-primary' @click="$refs.createReworkRef.show()">创建售后</button>

    <b-modal
      :hide-header="false"
      ref="createReworkRef"
      size:="md">
      <form id="create-rework-form">
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">备注</label>
          <div class="col-sm-7">
            <input type="text" class="form-control message">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">责任方</label>
          <div class="col-sm-7">
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="to_blame" value="printer" checked>
                  打印厂
              </label>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="to_blame" value="company">
                    第三方公司
                </label>
              </div>
          </div>
        </div>
      </form>

      <div slot="modal-footer" class="w-100">
        <button class="btn btn-primary float-right mx-5" @click="createRework">提交</button>
        <button class="btn btn-secondary float-right" @click="$refs.createReworkRef.hide();">取消</button>
       </div>
    </b-modal>

  </div>
</template>

<script type="text/javascript">
import {formatTime, standardTime} from '@/utils/time'

function createRework () {
  let toBlame = document.querySelector('input[name=to_blame]:checked').value
  let message = document.querySelector('.message').value

  this.$http.post('/api/orders/' + this.order.order_no + '/rework', {
    to_blame: toBlame,
    message: message
  }).then(response => {
    this.$refs.createReworkRef.hide()
    setTimeout(
      response => {
        location.href = '/orders?company_order_no=' + this.order.company_order_no
      }, 2000)
  })
}

export default {
  props: ['order'],
  methods: {
    formatTime,
    standardTime,
    createRework
  }
}
</script>

<style type="text/css" scoped>
  .create-after-sale{
    display: inline-block;
  }
</style>